import { css } from "@linaria/core";
import { units, fonts } from "@pm2/compat";

export const captionCls = css`
  --font-size: ${units.font.px(1.4 * 10)};
  --line-height: ${fonts.lineHeight(1.35)};

  box-sizing: border-box;
  width: 100%;

  display: block;

  font-family: ${fonts.body()};
  font-size: var(--font-size);
  font-style: italic;
  line-height: var(--line-height);

  &:empty {
    display: none;
  }
`;

export const contentCls = css`
  position: relative;
  z-index: 3;
`;

export const titleCls = css`
  font-weight: 700;
  font-style: normal;
`;

export const spanCls = css`
  display: inline;
`;
